import type { ReactNode } from 'react';
import { ReactComponent as AndroidIcon } from '../../assets/android.svg';
import { ReactComponent as AudioIcon } from '../../assets/audio.svg';
import { ReactComponent as CodeIcon } from '../../assets/code.svg';
import { ReactComponent as DocIcon } from '../../assets/doc.svg';
import { ReactComponent as ImageIcon } from '../../assets/image.svg';
import { ReactComponent as JsonIcon } from '../../assets/json.svg';
import { ReactComponent as PdfIcon } from '../../assets/pdf.svg';
import { ReactComponent as TableIcon } from '../../assets/table.svg';
import { ReactComponent as VideoIcon } from '../../assets/video.svg';
import { ReactComponent as ZipIcon } from '../../assets/zip.svg';
import { FileTypeIconName } from './fileTypeIcon.util';

export function FileTypeIcon({ name }: { name: FileTypeIconName }): ReactNode {
  switch (name) {
    case FileTypeIconName.TABLE:
      return <TableIcon />;
    case FileTypeIconName.CODE:
      return <CodeIcon />;
    case FileTypeIconName.JSON:
      return <JsonIcon />;
    case FileTypeIconName.ZIP:
      return <ZipIcon />;
    case FileTypeIconName.IMAGE:
      return <ImageIcon />;
    case FileTypeIconName.VIDEO:
      return <VideoIcon />;
    case FileTypeIconName.PDF:
      return <PdfIcon />;
    case FileTypeIconName.ANDROID:
      return <AndroidIcon />;
    case FileTypeIconName.AUDIO:
      return <AudioIcon />;
    case FileTypeIconName.DOC:
    default:
      return <DocIcon />;
  }
}
